import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

      export const updatedriverPaymentModel = createAsyncThunk('appDriverPaymentModel/Update', async (data) => {
        const response = await axios.post('https://api.zasway.com:8443/DriverPaymentModelAssignment/Update', data, {mode:'cors'})
        return response
      })

      export const getData = createAsyncThunk('appDriverPaymentModel/getData', async (params) => {
        const response = await axios.post('https://api.zasway.com:8443/DriverPaymentModelAssignment/GetTableSummary', params, {mode:'cors'})
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total
        }
      })


  export const appdriverPaymentModelSlice = createSlice({
    name: 'appDriverPaymentModel',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder
        
        .addCase(getData.fulfilled, (state, action) => {
          state.data = action.payload.data
          state.allData = action.payload.allData
          state.total = action.payload.totalPages
          state.params = action.payload.params
        })
       
    }
  })
  
  export default appdriverPaymentModelSlice.reducer
